import axios, { AxiosResponse } from "axios";
import { jobApplicationUrl } from "../utils";

export const deleteJobApplication = (
  applicationId: string
): Promise<AxiosResponse<any>> => {
  return axios.delete(jobApplicationUrl(applicationId));
};
